import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Baby, Moon, Thermometer, Timer, Heart } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
export const BonusSection = () => {
  const bonuses = [{
    icon: <Baby className="w-8 h-8 text-brand-lavender" data-id="element-13" />,
    title: 'Ebook Maestro "El Método Sueño Profundo"',
    desc: '6 capítulos con la estrategia completa paso a paso.',
    value: '$47'
  }, {
    icon: <Moon className="w-8 h-8 text-brand-lavender" data-id="element-14" />,
    title: 'El Protocolo de las 72 Horas',
    desc: 'La hoja de ruta exacta de qué hacer cada día y cada noche para resetear el reloj biológico.',
    value: '$97'
  }, {
    icon: <Thermometer className="w-8 h-8 text-brand-lavender" data-id="element-15" />,
    title: 'Guía de la Cueva del Sueño',
    desc: 'Cómo configurar la habitación (luz, sonido rosa y temperatura) para el éxito total.',
    value: '$29'
  }, {
    icon: <Timer className="w-8 h-8 text-brand-lavender" data-id="element-16" />,
    title: 'Técnica de la Pausa de 5 Minutos',
    desc: 'El secreto para que tu bebé aprenda a conectar ciclos de sueño sin que tú tengas que intervenir.',
    value: '$39'
  }, {
    icon: <Heart className="w-8 h-8 text-brand-lavender" data-id="element-17" />,
    title: 'Plan de Rescate para la Madre',
    desc: 'Estrategias reales para que tú también vuelvas a dormir 4 o 5 horas seguidas desde la primera noche.',
    value: '$49'
  }];
  return <section className="py-20 px-6 bg-white" data-id="element-18">
      <div className="max-w-4xl mx-auto" data-id="element-19">
        <div className="bg-gradient-to-b from-[#E8E0D4] to-[#F0EAE0] border-2 border-brand-gold rounded-3xl p-8 md:p-12 shadow-[0_0_20px_rgba(212,175,55,0.3),0_0_40px_rgba(212,175,55,0.1),0_10px_40px_rgba(0,0,0,0.1)] relative" data-id="element-20">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-brand-gold text-white font-bold px-6 py-2 rounded-full flex items-center gap-2 shadow-lg" data-id="element-21">
            <Gift className="w-5 h-5" data-id="element-22" />
            OFERTA ESPECIAL
          </div>

          <div className="text-center mb-12 mt-4" data-id="element-23">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-4" data-id="element-24">
              El Paquete Completo
            </h2>
            <p className="text-lg text-brand-charcoal/70" data-id="element-25">
              Todo lo que necesitas para recuperar tus noches, empaquetado en un
              solo lugar.
            </p>
          </div>

          <div className="space-y-6 mb-12" data-id="element-26">
            {bonuses.map((bonus, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex flex-col md:flex-row gap-6 items-start md:items-center p-6 bg-white rounded-2xl border-2 border-brand-gold/40 shadow-[0_2px_12px_rgba(212,175,55,0.15),0_4px_20px_rgba(0,0,0,0.06)] hover:shadow-[0_4px_20px_rgba(212,175,55,0.25),0_6px_24px_rgba(0,0,0,0.1)] hover:border-brand-gold/60 transition-all" data-id="element-27">
                <div className="w-20 h-20 flex-shrink-0 bg-brand-cream rounded-xl border border-brand-lavender/20 flex items-center justify-center" data-id="element-28">
                  {bonus.icon}
                </div>
                <div className="flex-1" data-id="element-29">
                  <h4 className="text-xl font-bold text-brand-navy mb-2" data-id="element-30">
                    {bonus.title}
                  </h4>
                  <p className="text-brand-charcoal/80 text-sm md:text-base" data-id="element-31">
                    {bonus.desc}
                  </p>
                </div>
                <div className="flex flex-col items-end flex-shrink-0 bg-brand-cream/50 px-4 py-3 rounded-lg border border-brand-gold/10 w-full md:w-auto" data-id="element-32">
                  <span className="text-sm text-brand-charcoal/60 line-through" data-id="element-33">
                    Valor: {bonus.value}
                  </span>
                  <span className="font-bold text-brand-teal" data-id="element-34">GRATIS HOY</span>
                </div>
              </motion.div>)}
          </div>

          <div className="bg-[#1A2640] text-white rounded-2xl text-center shadow-inner relative overflow-hidden" data-id="element-35">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/10 rounded-full blur-2xl" data-id="element-36"></div>
            <div className="absolute bottom-0 left-0 w-40 h-40 bg-brand-lavender/10 rounded-full blur-3xl" data-id="element-37"></div>

            <div className="relative z-10" data-id="element-38">
              <img src="https://cdn.magicpatterns.com/uploads/2Hx4Nk99JuEVHoD7DsJ1o1/LP5.png" alt="El Método Sueño Profundo - Paquete completo con ebook, guías, bonos y mini-curso" className="w-full max-w-2xl mx-auto -mt-4 mb-0" style={{
              mixBlendMode: 'lighten'
            }} data-id="element-39" />
              <div className="px-8 md:px-10 pb-8 md:pb-10 -mt-4" data-id="element-40">
                <p className="text-sm uppercase tracking-widest text-white/60 font-bold mb-6" data-id="element-41">
                  Valor Total del Paquete
                </p>

                <div className="flex flex-col items-center justify-center gap-3 mb-8" data-id="element-42">
                  <div className="flex items-center gap-4" data-id="element-43">
                    <span className="text-2xl md:text-3xl text-red-500 line-through font-bold decoration-red-500/80" data-id="element-44">
                      $67 USD
                    </span>
                    <span className="bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-45">
                      -91% OFF
                    </span>
                  </div>
                  <div className="text-5xl md:text-7xl font-bold" style={{
                  background: 'linear-gradient(170deg, #F5D060 0%, #D4AF37 40%, #B8962E 70%, #D4AF37 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  filter: 'drop-shadow(0 4px 0 rgba(154,123,31,0.6)) drop-shadow(0 6px 8px rgba(0,0,0,0.3))'
                }} data-id="element-46">
                    <PriceDisplay data-id="element-47" />
                  </div>
                  <p className="text-white/50 text-sm" data-id="element-48">
                    Precio por tiempo limitado
                  </p>
                </div>

                <a href="#pricing" className="btn-gold-3d inline-block w-full md:w-auto text-white font-bold text-xl py-5 px-12 rounded-xl transition-all transform hover:-translate-y-1 active:translate-y-0 tracking-wide uppercase" data-id="element-49">
                  ¡SÍ, QUIERO DORMIR OTRA VEZ!
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};